export default __webpack_public_path__ + "static/media/file-icon-pdf.da31547f.svg";